import React from "react";
import { Home, Lock, Camera, Leaf, Award, Truck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { TRUST_SIGNALS } from "@/data/content";

const ICONS = { Home, Lock, Camera, Leaf, Award, Truck };

export default function TrustBar() {
  return (
    <section className="border-y border-wood-900/10 bg-cream" data-testid="trust-signals">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8">
        <Reveal>
          <p className="text-center text-xs font-semibold uppercase tracking-[0.25em] text-sage">Why shop with us</p>
          <h2 className="mt-3 text-center font-serif text-3xl text-wood-900 md:text-4xl">Genuine reasons to feel at home</h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-6">
          {TRUST_SIGNALS.map((t, i) => {
            const Icon = ICONS[t.icon] || Home;
            return (
              <Reveal key={t.title} delay={i * 0.05}>
                <div className="flex flex-col items-center text-center">
                  <span className="flex h-14 w-14 items-center justify-center rounded-full bg-honey/15 text-honey-dark">
                    <Icon size={24} />
                  </span>
                  <h3 className="mt-4 font-serif text-lg text-wood-900">{t.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-wood-500">{t.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
